import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    let specificMessage = 'Something went wrong';

    if (!error.response) {
      // Network error, server down, or CORS
      specificMessage = 'Unable to connect to the backend server. Please check your internet connection or try again later.';
    } else if (error.response.status >= 500) {
      // Server/Database errors
      specificMessage = error.response.data?.message || 'Internal Server Error: Database or server encountered an issue. Please try again.';
    } else if (error.response.status === 401) {
      specificMessage = error.response.data?.message || 'Unauthorized access. Please log in again.';
    } else if (error.response.status === 403) {
      specificMessage = error.response.data?.message || 'You do not have permission to perform this action.';
    } else {
      // Validation or other client errors
      specificMessage = error.response.data?.message || error.message || 'Something went wrong';
    }

    // Reconstruct the error object so that all existing catch blocks 
    // doing `error.response?.data?.message` can successfully read the specific message.
    const customError = {
      ...error,
      response: {
        ...error.response,
        data: {
          ...error.response?.data,
          message: specificMessage,
        },
        status: error.response?.status,
      },
      message: specificMessage,
    };

    return Promise.reject(customError);
  }
);

export default axiosInstance;
